import { Box, Grid, Typography, useMediaQuery, useTheme } from "@mui/material";
import { OilAndGasHeroBG } from "../../constant";

export default function OilAndGasLanding() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Box
      sx={{
        position: "relative",
        minHeight: { xs: "50vh", md: "80vh" },
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
      }}
    >
      {/* Background Video */}
      <Box
        sx={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh", // Use dvh for mobile browsers
          minHeight: "-webkit-fill-available", // Better mobile support
          zIndex: -1,
          overflow: "hidden",
          pointerEvents: "none",
          background: "black",
          "::after": {
            content: '""',
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(0, 0, 0, 0.5)",
            zIndex: 1,
          },
        }}
      >
        <video
          autoPlay
          loop
          muted
           playsInline
  preload="metadata"
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            objectPosition: "center",
            //transform: "scaleX(-1)",
            //filter: "brightness(0.5)",
            minHeight: "-webkit-fill-available",
          }}
        >
          <source src={OilAndGasHeroBG} type="video/webm" />
          Your browser does not support the video tag.
        </video>
      </Box>

      {/* Content Overlay */}
      <Box
        sx={{
          position: "relative",
          zIndex: 1,
          width: "100%",
          height: "100%",
          padding: { xs: 2, sm: 4, md: 6 },
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          margin: "0 auto",
          alignItems: "center",
          flex: 1,
        }}
      >
        {/* Title Box */}
        <Box
          display="flex"
          justifyContent="center"
          flexDirection="column"
          alignItems="center"
          sx={{
            width: "100%",
            maxWidth: "1200px",
            textAlign: "left",
            py: 4,
            mt: 4,
          }}
        >
          <Grid container spacing={0}>
            <Grid xs={12} sm={12} md={8} lg={8}>
              <Typography
                variant="h2"
                sx={{
                  background:
                    "linear-gradient(135deg, #6366F1 0%, #3B82F6 100%)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                  fontSize: { xs: "24px", sm: "32px", md: "48px" },
                  fontWeight: 700,
                  mb: 2,
                  textAlign: "start",
                  letterSpacing: isMobile ? "0px" : "-2.4px",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                {`Digital Solutions for the Entire Oil   & Gas Value Chain`}
              </Typography>
            </Grid>
            <Grid xs={12} sm={12} md={6} lg={6}>
              <Typography
                sx={{
                  color: "white",
                  fontSize: { xs: "14px", md: "16px" },
                  lineHeight: 1.8,
                  textAlign: "start",
                  marginTop: 5,
                }}
              >
{"From exploration and production to transportation, refining, distribution, and fuel retail, IENERGY empowers oil & gas organizations with integrated solutions for safety, sustainability, connected operations, intelligent decision-making, and regulatory compliance—helping drive operational excellence across every asset, workforce, and business process. "}              </Typography>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </Box>
  );
}